export default {
    namespaced: true,
    state: () => ({
        start_date: null,
        end_date: null,
        selectedStoreId: null,
        selectedAreaId: null,
        selectedAlertId: null,
    }),
    getters: {
        startDate(state) {
            return state.start_date
        },
        endDate (state) {
            return state.end_date
        },
        selectedStoreId (state) {
            return state.selectedStoreId
        },
        selectedAreaId (state) {
            return state.selectedAreaId
        },
        selectedAlertId (state) {
            return state.selectedAlertId
        }
    },
    mutations: {
        setStartDate(state, payload) {
            state.start_date = payload
        },
        setEndDate(state, payload) {
            state.start_date = payload
        },
        setStoreId(state, payload) {
            state.selectedStoreId = payload
        },
        setAreaId(state, payload) {
            state.selectedAreaId = payload
        },
        setAlertId(state, payload) {
            state.selectedAlertId = payload
        },
    },
    actions: {
        setStartDate({ commit }, startDate) {
            commit('setStartDate', startDate )
        },
        setEndDate({ commit }, endDate) {
            commit('setEndDate', endDate )
        },
        setStoreId({ commit }, selectedStoreId) {
            commit('setStoreId', selectedStoreId )
        },
        setAreaId({ commit }, selectedAreaId) {
            commit('setAreaId', selectedAreaId )
        },
        setAlertId({ commit }, selectedAlertId) {
            commit('setAlertId', selectedAlertId )
        },
    },
}
